<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header card-header-flex align-items-center flex-column flex-sm-row py-3">
                    <div class="d-flex justify-content-center mr-3 mr-md-auto mb-2 mb-sm-0">
                        <a-switch v-model="realtime" class="mr-3">
                            <a-tooltip slot="checkedChildren" placement="top">
                                <template slot="title">
                                    <span>Realtime</span>
                                </template>
                                <fa-icon :icon="['fas', 'clock']" />
                            </a-tooltip>

                            <a-tooltip slot="unCheckedChildren" placement="top">
                                <template slot="title">
                                    <span>Histórico</span>
                                </template>
                                <fa-icon :icon="['fas', 'history']" />
                            </a-tooltip>
                        </a-switch>

                        <h5 class="mb-0">
                            Seguimiento
                            <sup class="text-secondary">
                                <fa-icon :icon="['fas', realtime ? 'clock' : 'history']" />
                                {{ realtime ? 'Tiempo real' : 'Histórico' }}
                            </sup>
                        </h5>
                    </div>
                    <div class="d-flex align-items-center">
                        <g-field
                            v-model="user"
                            app="positions"
                            type="user"
                            name="user"
                            placeholder="Usuario"
                            :clean="true"
                            class="mr-4"
                        />
                        <a-range-picker
                            v-show="!realtime"
                            v-model="date"
                            :placeholder="['Desde', 'Hasta']"
                            :ranges="{
                                Hoy: [$moment(), $moment()],
                                Ayer: [$moment().subtract(1, 'days'), $moment().subtract(1, 'days')],
                            }"
                        />
                    </div>
                </div>
                <div class="card-body p-0">
                    <gmap-map :center="mapCenter" :zoom="18" style="width: 100%; height: 600px">
                        <template v-if="positions.length">
                            <gmap-marker
                                v-for="(marker, index) in markers"
                                :key="index"
                                :position="marker"
                                :icon="markerIcon"
                                :zoom="17"
                                :clickable="true"
                                :draggable="true"
                                @click="openInfoWindow(marker)"
                            />
                            <gmap-polyline
                                v-for="pair in poly"
                                :key="pair.index"
                                :path="pair.line"
                                :options="{ strokeColor: pair.color }"
                                :editable="false"
                            />
                            <gmap-info-window
                                :options="map.infoOptions"
                                :position="mapCenter"
                                :opened="map.open"
                                @closeclick="closeInfoWindow"
                            />
                        </template>
                    </gmap-map>
                </div>
            </div>
        </div>

        {{ env }}
    </div>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDNn6sg2TQBEkSygrLfDKh_LaLI9P58nUQ',
        libraries: 'places',
    },
})

export default {
    name: 'Positions',
    data() {
        return {
            view: 'positionTracker',
            map: {
                open: false,
                infoOptions: {
                    infoContent: '',
                    pixelOffset: {
                        width: 5,
                        height: -15,
                    },
                },
                center: null,
            },
            user: {
                key: '',
                label: 'Selecciona un usuario',
            },
            realtimeInterval: null,
            env: process.env,
        }
    },
    computed: {
        mapCenter: {
            get() {
                if (this.map.center != null) {
                    return this.map.center
                }
                if (!this.positions.length) {
                    return { lat: 43.3408999, lng: -3.4002949 }
                }
                return this.positions[this.positions.length - 1]
            },
            set(val) {
                this.map.center = val
            },
        },
        markerIcon() {
            // eslint-disable-next-line global-require
            const icon = require('@/application/assets/images/marker.png')
            return {
                url: icon,
                scaledSize: {
                    width: 10,
                    height: 10,
                    f: 'px',
                    b: 'px',
                },
                anchor: { x: 0, y: 6 },
            }
        },
        positions() {
            const data = this.$gestios.$cache.view(this.scope)

            if (!data) return []

            return data.results.map((r) => ({
                ...r,
                lat: parseFloat(r.lat),
                lng: parseFloat(r.lng),
            }))
        },
        markers() {
            if (this.positions.length) {
                return [this.positions[0], this.positions[this.positions.length - 1]]
            }
            return []
        },
        poly() {
            const data = this.$gestios.$cache.view(this.scope)
            if (!data) return []

            return data.results.reduce((lines, r, index, arr) => {
                if (!index) return lines

                const color = `hsl(${Math.abs(Math.floor(parseFloat(r.speed)) - 130)}, 100%, 50%)`

                const line = {
                    index: index + String.fromCharCode(Math.random() * 7),
                    color,
                    line: [
                        {
                            lat: parseFloat(arr[index - 1].lat),
                            lng: parseFloat(arr[index - 1].lng),
                        },
                        {
                            lat: parseFloat(r.lat),
                            lng: parseFloat(r.lng),
                        },
                    ],
                }

                return [...lines, line]
            }, [])
        },
        scope() {
            const timestamFrom = this.$moment(this.date[0]).startOf('day').format('X')
            const timestampTo = this.$moment(this.date[1]).startOf('day').format('X')

            const userId = this.user ? this.user.key : 0
            const scope = `dashboard_positions_${userId}_${timestamFrom}_${timestampTo}`

            return scope
        },
        realtime: {
            get() {
                return this.$vault.get('lg_dash_realtime') || false
            },
            set(val) {
                return this.$vault.set('lg_dash_realtime', val)
            },
        },
        date: {
            get() {
                return this.$vault.get('lg_dash_date') || [this.$moment().subtract(1, 'days'), this.$moment()]
            },
            set(val) {
                return this.$vault.set('lg_dash_date', val)
            },
        },
        savedUser: {
            get() {
                return this.$vault.get('lg_dash_user') || ''
            },
            set(val) {
                return this.$vault.set('lg_dash_user', [val.key, val.label])
            },
        },
    },
    watch: {
        user(val) {
            this.savedUser = val
            this.loadPositions()
        },
        realtime() {
            this.loadPositions()
        },
        date() {
            this.loadPositions()
        },
        scope(newVal, oldVal) {
            this.$gestios.$cache.wipe(oldVal)
        },
    },
    created() {
        if (this.savedUser) this.user = { key: this.savedUser[0], label: this.savedUser[1] }
        this.loadPositions()
    },
    methods: {
        async loadPositions() {
            if (this.user.key) {
                if (this.realtime) this.realtimePositions()
                else this.historicPositions()
            }
        },
        async historicPositions(force) {
            this.loaded = false

            if (!this.positions.busy || force) {
                const timestamFrom = this.$moment(this.date[0]).startOf('day').format('X')
                const timestampTo = this.$moment(this.date[1]).startOf('day').format('X')

                const filter = [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {
                            _EntityCreateUser: {
                                type: 3,
                                int: this.user.key,
                                opt: '=',
                            },
                        },
                    },
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {
                            timestamp: {
                                type: 3,
                                int: timestamFrom,
                                opt: '>=',
                            },
                        },
                    },
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {
                            timestamp: {
                                type: 3,
                                int: timestampTo,
                                opt: '<=',
                            },
                        },
                    },
                ]

                const result = await this.$gestios.items('positions').list({
                    page: 1,
                    filters: filter,
                    limit: 100,
                    view: this.scope,
                    reset: true,
                })

                if (result.ok && (!result.data || result.data.length === 0)) {
                    this.$message.error('No se han encontrado posiciones para estos filtros.')
                }
            }

            this.loaded = true
        },
        async realtimePositions() {
            const firstHour = new Date()
            firstHour.setHours(1, 0, 0)

            const today = new Date()
            if (today.getTime() < firstHour.getTime()) today.setDate(today.getDate() - 1)

            const filter = [
                {
                    _ParentOperator: 'AND',
                    _Operator: 'AND',
                    Fields: {
                        _EntityCreateUser: {
                            type: 3,
                            int: this.user.key,
                            opt: '=',
                        },
                    },
                },
                {
                    _ParentOperator: 'OR',
                    _Operator: 'AND',
                    Fields: {
                        timestamp: {
                            type: 3,
                            opt: '>=',
                            int: today.getTime(),
                        },
                    },
                },
            ]

            const lastPosition = await this.$gestios.items('positions').list({
                page: 1,
                filters: filter,
                order: { timestamp: 'desc' },
                limit: 1,
                silent: true,
                view: this.scope,
            })

            if (lastPosition.ok) {
                if (lastPosition.total === 0)
                    this.$message.warning(`Hace más de 1 hora que ${this.user.data.Nick} no transmite posiciones`)

                // at last call the interval for a "realtime"
                if (lastPosition.total) {
                    this.clearMapData(true)

                    this.realtimeInterval = setInterval(() => {
                        this.realtimePositions()
                    }, 10000)
                }
            }
        },
        clearMapData(disableNotification) {
            // clear realtime interval
            if (this.realtimeInterval !== null) {
                clearInterval(this.realtimeInterval)
                this.realtimeInterval = null

                if (!disableNotification) this.$message.info('Pausado el seguimiento en tiempo real.')
            }
        },
        openInfoWindow(marker) {
            this.map.open = true
            this.map.center = { lat: marker.lat, lng: marker.lng }

            this.map.infoOptions.infoContent = `<br> <b>Fecha: ${this.$moment(parseInt(marker.timestamp, 10)).format(
                'YYYY-MM-DD HH:ss'
            )} </b><br> <b>Velocidad: ${Math.floor(marker.speed)} Km/s </b>`
        },
        closeInfoWindow() {
            this.map.open = false
        },
    },
}
</script>

<style lang="scss" scoped></style>
